package com.ervasstudio.tracoemovimento.pages.sobre

import androidx.compose.runtime.*
import com.ervasstudio.tracoemovimento.components.sections.Footer
import com.ervasstudio.tracoemovimento.util.Res
import com.ervasstudio.tracoemovimento.util.Res.Image.damiao
import com.ervasstudio.tracoemovimento.util.Res.Image.darling
import com.ervasstudio.tracoemovimento.util.Res.Image.lucien
import com.ervasstudio.tracoemovimento.util.Res.Image.marcos
import com.ervasstudio.tracoemovimento.util.Res.Image.narciso
import com.ervasstudio.tracoemovimento.util.Res.Image.santana
import com.ervasstudio.tracoemovimento.util.Res.Strings.ABOUT_US_PARAGRAPH_1
import com.ervasstudio.tracoemovimento.util.Res.Strings.ABOUT_US_PARAGRAPH_1_LINE_1
import com.ervasstudio.tracoemovimento.util.Res.Strings.ABOUT_US_PARAGRAPH_1_LINE_2
import com.ervasstudio.tracoemovimento.util.Res.Strings.ABOUT_US_PARAGRAPH_1_LINE_3
import com.ervasstudio.tracoemovimento.util.Res.Strings.ABOUT_US_PARAGRAPH_2
import com.ervasstudio.tracoemovimento.util.Res.Strings.ABOUT_US_PARAGRAPH_2_LINE_1
import com.ervasstudio.tracoemovimento.util.Res.Strings.ABOUT_US_PARAGRAPH_2_LINE_2
import com.ervasstudio.tracoemovimento.util.Res.Strings.ABOUT_US_PARAGRAPH_2_LINE_3
import com.ervasstudio.tracoemovimento.util.Res.Strings.ABOUT_US_PARAGRAPH_3
import com.ervasstudio.tracoemovimento.util.Res.Strings.ABOUT_US_PARAGRAPH_3_LINE_1
import com.ervasstudio.tracoemovimento.util.Res.Strings.ABOUT_US_PARAGRAPH_3_LINE_2
import com.ervasstudio.tracoemovimento.util.Res.Strings.ABOUT_US_PARAGRAPH_3_LINE_3
import com.ervasstudio.tracoemovimento.util.Res.Strings.ABOUT_US_PARAGRAPH_4
import com.ervasstudio.tracoemovimento.util.Res.Strings.ABOUT_US_PARAGRAPH_4_LINE_1
import com.ervasstudio.tracoemovimento.util.Res.Strings.ABOUT_US_PARAGRAPH_4_LINE_2
import com.ervasstudio.tracoemovimento.util.Res.Strings.ABOUT_US_PARAGRAPH_4_LINE_3
import com.ervasstudio.tracoemovimento.util.Res.Strings.ABOUT_US_PARAGRAPH_4_LINE_4
import com.ervasstudio.tracoemovimento.util.Res.Strings.ABOUT_US_PARAGRAPH_4_LINE_5
import com.ervasstudio.tracoemovimento.util.Res.Strings.ABOUT_US_PARAGRAPH_5
import com.ervasstudio.tracoemovimento.util.Res.Strings.ABOUT_US_PARAGRAPH_5_LINE_1
import com.ervasstudio.tracoemovimento.util.Res.Strings.ABOUT_US_PARAGRAPH_5_LINE_2
import com.ervasstudio.tracoemovimento.util.Res.Strings.ABOUT_US_PARAGRAPH_5_LINE_3
import com.ervasstudio.tracoemovimento.util.Res.Strings.ABOUT_US_PARAGRAPH_6
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.graphics.Colors.White
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*


@Composable
fun MainSectionSobre(isMobile: Boolean) {
    val team = listOf(
        TeamMember(damiao, "Damião Meponda", "Videógrafo"),
        TeamMember(darling, "Darling Catar", "Directora Criativa"),
        TeamMember(santana, "Santana", "Ilustrador"),
        TeamMember(lucien, "Lucien Monteiro", "Comercial"),
        TeamMember(marcos, "Marcos Catar", "Gestor financeiro"),
        TeamMember(narciso, "Narciso Mboa", "Director"),
    )

    Column(
        modifier = Modifier
            .fillMaxSize()
            .padding(topBottom = 4.cssRem),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {

        // --- 1. TÍTULO: SOBRE NÓS (Centralizado na página) ---
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .maxWidth(1200.px) // Alinha com a largura máxima do conteúdo
                .margin(bottom = if (isMobile) 2.cssRem else 4.cssRem)
                .padding(left = if (isMobile) 1.cssRem else 0.cssRem)
            ,

            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                "SOBRE",
                modifier = Modifier
                    .fontSize(if (isMobile) 80.px else 160.px)
                    .fontFamily("Gotham")
                    .fontWeight(FontWeight.Bold)
                    .lineHeight(0.9)
                    .color(White)
            )
            SpanText(
                "NÓS",
                modifier = Modifier
                    .fontSize(if (isMobile) 80.px else 160.px)
                    .fontFamily("Gotham")
                    .fontWeight(FontWeight.Bold)
                    .lineHeight(0.9)
                    .color(White)
            )
        }

        // --- 2. CARROSSEL DE EQUIPE (SUPERIOR) ---
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .margin(bottom = if (isMobile) 0.cssRem else 4.cssRem),
            horizontalArrangement = Arrangement.Center
        ) {
            TeamCarousel(members = team, visibleCount = if (isMobile) 2 else 5, isMobile = isMobile)
        }

        // --- 3. BLOCO DE CONTEÚDO CENTRAL (Texto + Elementos Laterais Flutuantes) ---
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .styleModifier {
                    // Impede o bloco de se espalhar infinitamente em ecrãs ultra-wide
                    property("max-width", if (isMobile) "768" else "1600px")
                },
            horizontalArrangement = Arrangement.Center,
            //verticalAlignment = Alignment.CenterVertically // Centraliza o foguete e estrela verticalmente em relação ao bloco de texto
        ) {

            // Coluna Esquerda: Foguete (Ocupa espaço flexível e empurra o conteúdo)
            Column(
                modifier = Modifier
                    .weight(1f) // Divide o ecrã dinamicamente
                    .padding(right = if (isMobile) 1.cssRem else 3.cssRem)
                    .align(Alignment.Bottom),

                horizontalAlignment = Alignment.End,
                verticalArrangement = Arrangement.Center
            ) {
                Image(
                    src = Res.Image.fuguetao,
                    modifier = Modifier
                        .width(if(isMobile) 4.cssRem else 20.cssRem)
                )
            }

            // Coluna Central: O Bloco de Texto (Largura travada para manter a quebra linha a linha perfeita)
            Column(
                modifier = Modifier
                    .width(if (isMobile) 20.cssRem else 52.cssRem) // Tamanho cirúrgico baseado no comprimento das linhas de texto da imagem
                    .flexShrink(0)   // Não deixa o zoom esmagar a largura do texto
                    .padding(topBottom = if (isMobile) 1.cssRem else 9.cssRem),
                verticalArrangement = Arrangement.spacedBy(0.5.cssRem)
            ) {

                if (isMobile) {

                    AboutUsParagraph(
                        ABOUT_US_PARAGRAPH_1,
                        isMobile = isMobile
                    )

                    Box(modifier = Modifier.height(if (isMobile) 1.cssRem else 1.5.cssRem))

                    AboutUsParagraph(
                        ABOUT_US_PARAGRAPH_2,
                        isMobile = isMobile
                    )

                    Box(modifier = Modifier.height(if (isMobile) 1.cssRem else 1.5.cssRem))

                    AboutUsParagraph(
                        ABOUT_US_PARAGRAPH_3,
                        isMobile = isMobile
                    )

                    Box(modifier = Modifier.height(if (isMobile) 1.cssRem else 1.5.cssRem))

                    AboutUsParagraph(
                        ABOUT_US_PARAGRAPH_4,
                        isMobile = isMobile
                    )

                    AboutUsParagraph(
                        ABOUT_US_PARAGRAPH_5,
                        isMobile = isMobile
                    )

                    Box(modifier = Modifier.height(if (isMobile) 1.cssRem else 1.5.cssRem))

                    AboutUsParagraph(
                        ABOUT_US_PARAGRAPH_6,
                        isMobile = isMobile
                    )

                } else {
                    AboutUsParagraph(ABOUT_US_PARAGRAPH_1_LINE_1, isMobile = isMobile)
                    AboutUsParagraph(
                        ABOUT_US_PARAGRAPH_1_LINE_2,
                        isMobile = isMobile
                    )
                    AboutUsParagraph(ABOUT_US_PARAGRAPH_1_LINE_3, isMobile = isMobile)

                    Box(modifier = Modifier.height(if (isMobile) 1.cssRem else 1.5.cssRem))

                    AboutUsParagraph(ABOUT_US_PARAGRAPH_2_LINE_1, isMobile = isMobile)
                    AboutUsParagraph(
                        ABOUT_US_PARAGRAPH_2_LINE_2,
                        isMobile = isMobile
                    )
                    AboutUsParagraph(ABOUT_US_PARAGRAPH_2_LINE_3, isMobile = isMobile)

                    Box(modifier = Modifier.height(if (isMobile) 1.cssRem else 1.5.cssRem))

                    AboutUsParagraph(ABOUT_US_PARAGRAPH_3_LINE_1, isMobile = isMobile)
                    AboutUsParagraph(
                        ABOUT_US_PARAGRAPH_3_LINE_2,
                        isMobile = isMobile
                    )
                    AboutUsParagraph(ABOUT_US_PARAGRAPH_3_LINE_3, isMobile = isMobile)

                    Box(modifier = Modifier.height(if (isMobile) 1.cssRem else 1.5.cssRem))

                    AboutUsParagraph(ABOUT_US_PARAGRAPH_4_LINE_1, isMobile = isMobile)
                    AboutUsParagraph(
                        ABOUT_US_PARAGRAPH_4_LINE_2,
                        isMobile = isMobile
                    )
                    AboutUsParagraph(ABOUT_US_PARAGRAPH_4_LINE_3, isMobile = isMobile)
                    AboutUsParagraph(
                        ABOUT_US_PARAGRAPH_4_LINE_4,
                        isMobile = isMobile
                    )
                    AboutUsParagraph(ABOUT_US_PARAGRAPH_4_LINE_5, isMobile = isMobile)

                    Box(modifier = Modifier.height(if (isMobile) 1.cssRem else 1.5.cssRem))

                    AboutUsParagraph(ABOUT_US_PARAGRAPH_5_LINE_1, isMobile = isMobile)
                    AboutUsParagraph(ABOUT_US_PARAGRAPH_5_LINE_2, isMobile = isMobile)
                    AboutUsParagraph(ABOUT_US_PARAGRAPH_5_LINE_3, isMobile = isMobile)
                }

            }

            // Coluna Direita: Estrela de 4 Pontas (Ocupa o mesmo espaço flexível da esquerda)
            Column(
                modifier = Modifier
                    .weight(1f),
                horizontalAlignment = Alignment.Start,
                verticalArrangement = Arrangement.Center
            ) {
                Image(
                    src = Res.Image.ovni,
                    modifier = Modifier
                        .width(if (isMobile) 4.cssRem else 20.cssRem)

                )
            }
        }

        Row(modifier = Modifier.height(if (isMobile) 0.px else 3.cssRem)) {}

        // --- 4. CARROSSEL DE EQUIPE (INFERIOR) ---
        // Sem vh fixos no bloco anterior, esta Box vai colar-se organicamente abaixo do texto
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .margin(bottom = if (isMobile) 0.px else 4.cssRem),
            horizontalArrangement = Arrangement.Center
        ) {
            TeamCarousel(members = team, visibleCount = if (isMobile) 2 else 5, isTop = false, isMobile = isMobile)
        }


        Footer(
            isHome = false,
            isMobile = isMobile,
        )
    }

}

// Função auxiliar para parágrafos com estilo
@Composable
fun AboutUsParagraph(text: String, isMobile: Boolean) {

    SpanText(
        text = text,
        modifier = Modifier
            .fontSize(if (isMobile) 14.px else 26.px)
            .fontFamily("museomoderno")
// .fontWeight(FontWeight.Bold)
            .overflow(Overflow.Hidden)
            .lineHeight(1.1)
            .color(White),
    )
}


